import { Box, Card, CardContent, Typography } from '@mui/material'

type Props = {
  labelLeft: string
  labelRight: string
  valueLeft: number
  valueRight: number
  textColor?: 'default' | 'red'
}

const MetricsCard = ({
  labelLeft,
  labelRight,
  valueLeft,
  valueRight,
  textColor = 'default'
}: Props) => {
  const color = textColor === 'red' ? 'error.main' : 'text.primary'

  return (
    <Card>
      <CardContent
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr'
        }}
      >
        <Box>
          <Typography fontSize={26} color={color}>
            {valueLeft}
          </Typography>
          <Typography color="text.secondary" fontSize={14}>
            {labelLeft}
          </Typography>
        </Box>
        <Box borderLeft={1} pl={4} borderColor="divider">
          <Typography fontSize={26} color={color}>
            {valueRight}
          </Typography>
          <Typography color="text.secondary" fontSize={14}>
            {labelRight}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  )
}

export default MetricsCard
